import React from 'react';

import { telemetryClickHandler } from '../telemetryHandler';
import type { CtaConfig, NavLink } from '../types';

interface TwoColumnMenuProps {
  links: NavLink[];
  cta?: CtaConfig;
  categories?: {
    title: string;
    items: NavLink[];
  };
}

export default function TwoColumnMenu({
  links,
  cta,
  categories,
}: TwoColumnMenuProps): JSX.Element {
  return (
    <div className="flex whitespace-nowrap rounded-2xl">
      {/* Left column — links + CTA */}
      <div className="flex flex-col gap-6 p-8">
        {links.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className="flex items-center gap-4 text-base font-semibold text-gray-900 hover:opacity-80 no-underline"
            onClick={telemetryClickHandler(
              link.telemetrySlug,
              link.telemetryEvents
            )}
          >
            {(link.stockblocksIcon || link.icon) && (
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white shadow-md">
                <img
                  src={link.stockblocksIcon || link.icon}
                  alt=""
                  width={24}
                  height={24}
                />
              </div>
            )}
            {link.label}
          </a>
        ))}
        {cta && (
          <a
            href={cta.href}
            className="flex h-10 items-center justify-center rounded-lg bg-blue-700 px-6 text-sm font-semibold text-white hover:bg-blue-800 no-underline"
            onClick={telemetryClickHandler(
              cta.telemetrySlug,
              cta.telemetryEvents
            )}
          >
            {cta.label}
          </a>
        )}
      </div>

      {/* Right column — categories */}
      {categories && (
        <div className="flex flex-col gap-5 bg-gray-100 p-8">
          <span className="text-base font-semibold text-gray-900">
            {categories.title}
          </span>
          {categories.items.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-gray-900 hover:opacity-80 no-underline"
              onClick={telemetryClickHandler(
                item.telemetrySlug,
                item.telemetryEvents
              )}
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
